module.exports = __webpack_public_path__ + "media/attorney/hero-be5a6d8a.png";